import React, { useEffect, useState } from "react";
import AutoCollectModal from "../../order-modal/AutoCollect";
import RequestPaymentModal from "../../order-modal/RequestPayment";
import ExemptDialog from "../EditOrderComponents/Modal/ExemptModal";
import {
  disable25Api,
  enable25Api,
  getHasArrear,
  hasUpdate,
  pausePay,
  sendAddCardLink,
  showCharge20,
} from "../../_redux/order/orderCrud";
import GracePeriodModal from "../../order-modal/GracePeriodModal";
import { isContainerOrder } from "../../lockoutGraceUtils";
import EmailCustomerModal from "../../order-modal/EmailCustomer";
import DynamicDialog from "../../../../../_metronic/_partials/widgets/alert/DynamicDialog";
import SnackBarTool from "../../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import PausePaymentModal from "../../order-modal/PausePaymentModal";
import {
  fetchBillingCardDetail,
  fetchMyOrderDetailCard,
  fetchMyOrderTimeline,
} from "../../_redux/order/orderAction";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import DeleteOrderModal from "../../order-modal/DeleteOrderModal";
import AddProductMainModal from "../EditOrderComponents/Modal/AddProductMainModal";
import { useContextState } from "../../reducer/editOrderStripeReducer";

/**
 * Billing actions dropdown, including lockout grace period for container orders.
 *
 * @param {object} props - Component props.
 * @param {object} props.intl - react-intl instance for translations.
 * @param {object} props.billingCard - Billing card payload from the order store.
 * @param {Function} props.setDialog - Setter for billing dialog state.
 * @param {object} props.orderDetail - Current order record.
 * @param {Function} props.setDialogRecur - Setter for the recurring-charges dialog.
 * @param {object} props.dialogRecur - Recurring-charges dialog state.
 * @param {Function} props.setEightCharge - Setter for the Charge 20 panel flag.
 * @param {Array} props.cardDetailArray - Saved payment cards for the customer.
 * @param {Function} props.setOpenInvoice - Setter for the invoice panel open state.
 * @param {boolean} props.hasArrear - Whether the order currently has arrears.
 * @param {Function} props.setSnack - Setter for snackbar notifications.
 * @param {object} props.snack - Current snackbar state.
 * @param {Function} props.setcallApiHas - Callback to refresh arrears after billing actions.
 * @param {boolean} props.loading - Whether a billing action is in progress.
 * @param {Function} props.setLoading - Setter for the billing-action loading flag.
 * @param {Function} [props.onGracePeriodUpdated] - Callback after lockout grace is saved.
 * @returns {JSX.Element} The billing actions dropdown.
 */
const BillingActionDropdown = ({
  intl,
  billingCard,
  setDialog,
  orderDetail,
  setDialogRecur,
  dialogRecur,
  setEightCharge,
  cardDetailArray,
  setOpenInvoice,
  hasArrear,
  setSnack,
  snack,
  setcallApiHas,
  loading,
  setLoading,
  onGracePeriodUpdated,
}) => {
  console.log("cardDetailArray", cardDetailArray);
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const [showHisInvoice, setHisInvoice] = useState(false);
  const [deleteOrderOpen, setDeleteOrderOpen] = useState(false);
  const role = useSelector((state) => state.auth.user.roles, shallowEqual);
  // Only super-admins may delete an order; the backend enforces this too.
  const isSuperAdmin = Array.isArray(role) && role[0] === "super-admin";

  const [dialogAuto, setDialogAuto] = useState({ check: false });
  const [dialogs, setDialogs] = useState({ check: false });
  const [dialogsOneTime, setDialogsOneTime] = useState({ update: false });
  const [dialogEmail, setDialogEmail] = useState({ check: false });
  const [cardDialog, setCardDialog] = useState({ modal: false });
  // const [snack, setSnack] = useState({ call: false, type: "", message: "" });

  const [excempt, setExcempt] = useState(false);
  const [charge, setCharge] = useState(true);
  // const [hasArrear, setHasArrear] = useState(null);
  const [hasDialog, setHasDialog] = useState({ modal: false });
  const [dialogPause, setDialogPause] = useState({ check: false });
  const [resumeDialog, setResumeDialog] = useState({ modal: false });
  const [resumeLoading, setResumeLoading] = useState(false);
  const [disable25, setDisable25] = useState({ modal: false });
  const [enable25, setEnable25] = useState({ modal: false });
  const [graceDialog, setGraceDialog] = useState({ check: false });
  const { state, dispatchReducer } = useContextState();

  useEffect(() => {
    if (orderDetail?.created_at) {
      let date = new Date("2023-05-18T09:15:16.000000Z").getTime();
      let orderDate = new Date(orderDetail?.created_at).getTime();
      if (orderDate <= date) {
        setHisInvoice(true);
      } else {
        setHisInvoice(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetail?.created_at]);

  useEffect(() => {
    if (orderDetail?.id) {
      showCharge20(orderDetail?.id).then((res) => {
        if (
          res?.data?.data?.twenty_percent_status !== 1 &&
          res?.data?.data?.eighty_percent_status !== 1
        ) {
          setCharge(true);
        } else {
          setCharge(false);
        }
        if (res?.data?.data?.eighty_percent_status) {
          setEightCharge(true);
        }
      });
    }
  }, [orderDetail?.id]);

  const handleCardDialog = () => {
    setLoading(true);
    setSnack({ call: false, type: "", message: "" });
    setCardDialog({ modal: false });
    const payload = {
      order_id: orderDetail?.id,
    };
    sendAddCardLink(payload)
      .then((res) => {
        setSnack({
          call: true,
          type: "success",
          message: res.data.message,
        });
        setcallApiHas(true);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setSnack({
          call: true,
          type: "error",
          message: error?.response?.data?.message,
        });
      });
  };
  const handleHas = (data) => {
    setSnack({ call: false, type: "", message: "" });
    hasUpdate(data)
      .then((res) => {
        setSnack({
          call: true,
          type: "success",
          message: res.data.message,
        });
        setcallApiHas(true);
        setTimeout(() => {
          setHasDialog({ modal: false });
        }, 2000);
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: error?.response?.data?.message,
        });
      });
  };

  const handleResume = (data) => {
    setResumeLoading(true);
    setSnack({ call: false, type: "", message: "" });
    pausePay(data)
      .then((res) => {
        dispatch(fetchMyOrderDetailCard(orderDetail?.id));
        dispatch(fetchMyOrderTimeline(orderDetail?.id));
        dispatch(
          fetchBillingCardDetail(
            orderDetail?.franchise_id,
            orderDetail?.subscription_data?.id,
            "",
            orderDetail?.customer_chargebee_id,
            orderDetail?.id
          )
        );
        setResumeLoading(false);

        setSnack({
          call: true,
          type: "success",
          message: res.data.message,
        });
        setTimeout(() => {
          setResumeDialog({ modal: false });
        }, 2000);
      })
      .catch((error) => {
        setResumeLoading(false);

        setSnack({
          call: true,
          type: "error",
          message: error?.response?.data?.message,
        });
      });
  };

  const handleDisablePrice = () => {
    setSnack({ call: false, type: "", message: "" });
    const payload = {
      order_id: orderDetail?.id,
    };
    disable25Api(payload)
      .then((res) => {
        setResumeLoading(false);

        setSnack({
          call: true,
          type: "success",
          message: res.data.message,
        });
        setTimeout(() => {
          setDisable25({ modal: false });
        }, 2000);
      })
      .catch((error) => {
        setResumeLoading(false);

        setSnack({
          call: true,
          type: "error",
          message: error?.response?.data?.message,
        });
      });
  };

  const handleEnablePrice = () => {
    setSnack({ call: false, type: "", message: "" });
    const payload = {
      order_id: orderDetail?.id,
    };
    enable25Api(payload)
      .then((res) => {
        setResumeLoading(false);

        setSnack({
          call: true,
          type: "success",
          message: res.data.message,
        });
        setTimeout(() => {
          setEnable25({ modal: false });
        }, 2000);
      })
      .catch((error) => {
        setResumeLoading(false);

        setSnack({
          call: true,
          type: "error",
          message: error?.response?.data?.data?.output,
        });
      });
  };

  return (
    <>
      <ul className="navi navi-hover">
        <li className="navi-item pointer">
          <span
            className="navi-link"
            onClick={() => setOpenInvoice({ open: true, check: "invoice" })}
          >
            <span className="navi-text">
              {intl.formatMessage({ id: "Invoices" })}
            </span>
          </span>
        </li>
        {orderDetail?.subscription_id &&
          orderDetail?.subscription_id?.includes("sub_") && (
            <li className="navi-item pointer">
              <span className="navi-link" id="kt_EditNextBilling_panel_toggle">
                <span className="navi-text">
                  {intl.formatMessage({ id: "Edit.Next.Billing.Date" })}
                </span>
              </span>
            </li>
          )}
        <li className="navi-item pointer">
          <span className="navi-link" id="kt_EditAdhocCharge_panel_toggle">
            <span className="navi-text">
              {intl.formatMessage({ id: "Create.Hoc.Charge" })}
            </span>
          </span>
        </li>
        <li className="navi-item pointer">
          <span className="navi-link">
            <span
              className="navi-text"
              onClick={() =>
                setDialogsOneTime({
                  check: true,
                  title: "Add Charge",
                  type: "charges",
                })
              }
            >
              One time charge
            </span>
          </span>
        </li>
        {/* {billingCard?.old_unpaid_invoice !== "" && (
          <li className="navi-item pointer">
            <span className="navi-link" id="kt_PaymentPlan_panel_toggle">
              <span className="navi-text">
                {intl.formatMessage({ id: "Payment.Plan" })}
              </span>
            </span>
          </li>
        )} */}
        {/* {billingCard?.old_unpaid_invoice !== "" && (
          <li className="navi-item pointer">
            <span className="navi-link" id="kt_PartPayment_panel_toggle">
              <span className="navi-text">
                {intl.formatMessage({ id: "Part.Payment" })}
              </span>
            </span>
          </li>
        )} */}
        {orderDetail?.subscription_data &&
        orderDetail.subscription_data.subscription ? (
          orderDetail.subscription_data.subscription?.pause_collection !==
          null ? (
            <span>
              <li className="navi-item pointer">
                <span className="navi-link" id="kt_PutOnHold_panel_toggle">
                  <span className="navi-text">Resume Subscription</span>
                </span>
              </li>
            </span>
          ) : (
            <span>
              <li className="navi-item pointer">
                <span className="navi-link" id="kt_PutOnHold_panel_toggle">
                  <span className="navi-text">
                    {intl.formatMessage({ id: "Put.Hold" })}
                  </span>
                </span>
              </li>
            </span>
          )
        ) : (
          ""
        )}

        {orderDetail?.subscription_data?.status === "paused" ? (
          <li className="navi-item pointer">
            <span
              className="navi-link"
              onClick={() => setDialog({ type: true, check: "resume" })}
            >
              <span className="navi-text">
                {intl.formatMessage({ id: "Resume.Subscription" })}
              </span>
            </span>
          </li>
        ) : (
          ""
        )}
        {(orderDetail?.is_collection_completed !== 1 ||
          orderDetail?.subscription_data?.status !== "canceled") &&
        orderDetail?.is_cancel != 1 ? (
          <li className="navi-item pointer">
            <span className="navi-link" id="kt_CancelSubscription_panel_toggle">
              <span className="navi-text">
                {intl.formatMessage({ id: "Cancel.Subscription" })}
              </span>
            </span>
          </li>
        ) : (
          ""
        )}
        {showHisInvoice ? (
          <li className="navi-item pointer">
            <span
              className="navi-link"
              onClick={() =>
                setDialogRecur({
                  dialog: true,
                  orderId: orderDetail?.id,
                  bookRef: orderDetail?.booking_reference,
                  ordCreatedAt: orderDetail?.created_at,
                })
              }
            >
              <span className="navi-text">Historical Invoices</span>
            </span>
          </li>
        ) : (
          ""
        )}

        {/* {orderDetail?.subscription_id &&
        orderDetail?.payment_method === "card" &&
        cardDetailArray?.length > 0 ? (
          <li className="navi-item pointer">
            <span
              className="navi-link"
              onClick={() => setDialogAuto({ check: true })}
            >
              <span className="navi-text">Auto Collection</span>
            </span>
          </li>
        ) : null} */}

        {orderDetail?.subscription_id &&
          orderDetail?.subscription_id?.includes("sub") &&
          orderDetail?.subscription_data?.subscription?.pause_collection ==
            null && (
            <li className="navi-item pointer">
              <span
                className="navi-link"
                onClick={() => setDialogPause({ check: true })}
              >
                <span className="navi-text">Pause Payment Collection</span>
              </span>
            </li>
          )}
        {
          <li className="navi-item pointer">
            <span
              className="navi-link"
              onClick={() =>
                setResumeDialog({
                  modal: true,
                  funData: {
                    order_id: orderDetail?.id || "",
                    auto_collection: "on",
                  },
                })
              }
            >
              <span className="navi-text">Resume Payment Collection</span>
            </span>
          </li>
        }

        {/* {orderDetail?.subscription_id && (<li className="navi-item pointer">
          <span
            className="navi-link"
            onClick={() => setDialogs({ check: true })}
          >
            <span className="navi-text">Email for payment</span>
          </span>
        </li>)} */}
        <li className="navi-item pointer">
          <span
            className="navi-link"
            onClick={() => setDialogEmail({ check: true })}
          >
            <span className="navi-text">Resend Order Confirmation Email</span>
          </span>
        </li>
        <li className="navi-item pointer">
          <span className="navi-link" onClick={() => setExcempt(true)}>
            <span className="navi-text">EXEMPT Automated Price Inc</span>
          </span>
        </li>
        {isContainerOrder(orderDetail) && (
          <li className="navi-item pointer">
            <span
              className="navi-link"
              onClick={() => setGraceDialog({ check: true })}
            >
              <span className="navi-text">Grace Period</span>
            </span>
          </li>
        )}
        <li className="navi-item pointer">
          <span
            className="navi-link"
            onClick={() => setCardDialog({ modal: true })}
          >
            <span className="navi-text">Send Add Card Link</span>
          </span>
        </li>
        {hasArrear?.has_arrears && (
          <li className="navi-item pointer">
            <span
              className="navi-link"
              onClick={() =>
                setHasDialog({
                  modal: true,
                  funData: {
                    customer_id: orderDetail?.customer_old_chargebee_id,
                    is_arrear: 1,
                    // So the change is recorded on this order's timeline.
                    order_id: orderDetail?.id,
                  },
                })
              }
            >
              <span className="navi-text">No longer in arrears</span>
            </span>
          </li>
        )}
        {/* <li className="navi-item pointer">
          <span
            className="navi-link"
            onClick={() =>
              setDisable25({
                modal: true,
                funData: "",
              })
            }
          >
            <span className="navi-text">Disable 25% Price Increase</span>
          </span>
        </li>
        <li className="navi-item pointer">
          <span
            className="navi-link"
            onClick={() =>
              setEnable25({
                modal: true,
                funData: "",
              })
            }
          >
            <span className="navi-text">25% Price Increase</span>
          </span>
        </li> */}
        {isSuperAdmin && (
          <li className="navi-item pointer">
            <span className="navi-link" onClick={() => setDeleteOrderOpen(true)}>
              <span className="navi-text" style={{ color: "#D32F2F" }}>Delete order</span>
            </span>
          </li>
        )}
      </ul>
      {isSuperAdmin && (
        <DeleteOrderModal
          show={deleteOrderOpen}
          onHide={() => setDeleteOrderOpen(false)}
          orderDetail={orderDetail}
        />
      )}
      <AutoCollectModal
        orderDetail={orderDetail}
        dialog={dialogAuto}
        setDialog={setDialogAuto}
        billingCard={billingCard}
      />
      <PausePaymentModal
        orderDetail={orderDetail}
        dialog={dialogPause}
        setDialog={setDialogPause}
        billingCard={billingCard}
      />
      {dialogs.check && (
        <RequestPaymentModal
          dialog={dialogs}
          setDialog={setDialogs}
          orderDetail={orderDetail}
        />
      )}
      {dialogEmail.check && (
        <EmailCustomerModal
          dialog={dialogEmail}
          setDialog={setDialogEmail}
          orderDetail={orderDetail}
        />
      )}
      {excempt && (
        <ExemptDialog
          dialog={excempt}
          setDialog={setExcempt}
          orderId={orderDetail?.id}
        />
      )}
      {hasDialog.modal && (
        <DynamicDialog
          dialog={hasDialog}
          setDialog={setHasDialog}
          header={"No longer in arrears"}
          mainText={"Are you sure you want to perfome this action"}
          handleChange={handleHas}
        />
      )}
      {resumeDialog.modal && (
        <DynamicDialog
          dialog={resumeDialog}
          setDialog={setResumeDialog}
          header={"Resume payment collection"}
          mainText={
            "Are you sure you want to resume collecting payments? Any future invoices for this subscription will resume payment collection."
          }
          handleChange={handleResume}
          loading={resumeLoading}
        />
      )}
      {cardDialog.modal && (
        <DynamicDialog
          dialog={cardDialog}
          setDialog={setCardDialog}
          header={"Alert"}
          mainText={"Are you sure you want to perfome this action"}
          handleChange={handleCardDialog}
        />
      )}
      {disable25.modal && (
        <DynamicDialog
          dialog={disable25}
          setDialog={setDisable25}
          header={"Alert"}
          mainText={"Are you sure you want to perfome this action"}
          handleChange={handleDisablePrice}
        />
      )}
      {enable25.modal && (
        <DynamicDialog
          dialog={enable25}
          setDialog={setEnable25}
          header={"Alert"}
          mainText={"Are you sure you want to perfome this action"}
          handleChange={handleEnablePrice}
        />
      )}
      {dialogsOneTime?.check && (
        <AddProductMainModal
          dialog={dialogsOneTime}
          setDialog={setDialogsOneTime}
        />
      )}
      {graceDialog.check && (
        <GracePeriodModal
          dialog={graceDialog}
          setDialog={setGraceDialog}
          orderId={orderDetail?.id}
          onSuccess={onGracePeriodUpdated}
        />
      )}
      {/* {snack.call ? <SnackBarTool {...snack} /> : ""} */}
    </>
  );
};

export default BillingActionDropdown;
